import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Goal } from '@feathr/blackbox';
import { ContextMenu } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

interface IGoalManagerOptionsProps {
  goal: Goal;
}

function GoalManagerOptions({ goal }: Readonly<IGoalManagerOptionsProps>): JSX.Element {
  const { t } = useTranslation();

  const isArchived = goal.get('is_archived');

  return (
    <ContextMenu buttonType={'icon'} name={'goal-options'} position={'left-start'}>
      <ContextMenu.Item name={'edit-goal'} prefix={getIconForAction('edit')}>
        {t('Edit')}
      </ContextMenu.Item>
      {isArchived ? (
        <ContextMenu.Item name={'unarchive-goal'} prefix={getIconForAction('archive')}>
          {t('Unarchive')}
        </ContextMenu.Item>
      ) : (
        <ContextMenu.Item name={'archive-goal'} prefix={getIconForAction('archive')}>
          {t('Archive')}
        </ContextMenu.Item>
      )}
      <ContextMenu.Item name={'delete-goal'} prefix={getIconForAction('delete')} theme={'danger'}>
        {t('Delete')}
      </ContextMenu.Item>
    </ContextMenu>
  );
}

export default observer(GoalManagerOptions);
